import HRLayout from "../hr/HRLayout";
import useHRCopy from "../hr/i18n/useHRCopy";
import Reveal from "../hr/components/Reveal";
import PageHeader from "../hr/components/PageHeader";
import ContextRail from "../hr/components/ContextRail";
import CapabilityRow from "../hr/components/CapabilityRow";
import ContactForm from "../components/ContactForm";
import { CONTACT_EMAIL } from "../hr/contact";

export default function CalismaIlkelerimPage() {
  const copy = useHRCopy();
  const t = copy.pages.ilkeler;
  const r = copy.record;

  return (
    <HRLayout>
      <PageHeader title={t.title} lede={t.lede} />

      <section className="bg-white border-y border-line">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-20 grid gap-10 lg:gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4 lg:order-2">
            <Reveal delay={0.09}>
              <ContextRail
                tone="onWhite"
                title={r.details}
                rows={[
                  { term: r.location, value: r.locationValue },
                  { term: r.email, value: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}` },
                ]}
                linksTitle={r.related}
                links={[
                  { to: "/hakkimda", label: copy.pages.hakkimda.title },
                  { to: "/hizmetlerim", label: copy.pages.hizmetler.title },
                  { to: "/iletisim", label: copy.nav.contact },
                ]}
              />
            </Reveal>
          </div>

          {/* The values are a definition list, not a sequence — ruled rows,
              no numbering. */}
          <div className="lg:col-span-8 lg:order-1">
            <div className="border-t border-line">
              {t.values.map((v, i) => (
                <Reveal key={v.title} delay={i * 0.06}>
                  <CapabilityRow title={v.title} body={v.body} />
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <ContactForm title={t.contactLead.title} body={t.contactLead.body} />
    </HRLayout>
  );
}
